import {styled} from "@mui/material/styles";

export const Container = styled('div')(() => ({
    padding: '10px 20px',
    width: '100%',
}));